<template>
    <v-app :dark="true">
        <v-alert v-show="getShowAlert" :type="getAlertType" class="alert-component" dense >
            {{ getAlertText }}
        </v-alert>
        <spinner-component v-show="getSpinner"/>
        <v-row class="no-gutters">
            <v-col cols="12" sm="12">
                <Header v-if="this.$route.name !== 'login'"/>
                <v-main>
                    <router-view></router-view>
                </v-main>
            </v-col>
        </v-row>
    </v-app>
</template>

<script>
import SystemBarPart from "./components/Header/parts/SystemBarPart";
import Header from './components/Header/HeaderComponent';
import SpinnerComponent from "./components/Shared/SpinnerComponent";
import alert from './mixins/alert';
import spinner from "./mixins/spiner";
import { mapGetters, mapActions } from 'vuex';

export default {
    components: {
        Header,
        SpinnerComponent,
    },

    mixins: [alert, spinner],

    computed: {
        ...mapGetters(['GET_IS_LOGGET', 'GET_STATUS_THEME']),
    },

    methods: {
        ...mapActions(['A_CAR_TYPES', 'A_NOT_ISSUED_COUNT'])
    },

    async created() {
        if (!this.$store.getters.GET_IS_LOGGET) {
            await this.$store.dispatch('A_ME');
        }
        if (this.GET_STATUS_THEME === false || this.GET_STATUS_THEME === 'false') {
            this.$vuetify.theme.dark = false;
        } else {
            this.$vuetify.theme.dark = true;
        }
        await this.A_CAR_TYPES();
        await this.A_NOT_ISSUED_COUNT();
    },

    mounted() {
    }
}
</script>

<style lang="css">
::-webkit-scrollbar {
    width: 0;
}
.alert-component {
    position: fixed!important;
    animation: show 1s ease;
    right:0;
    top: 100px;
    z-index: 2;
    opacity: 0.8;
}

@keyframes show {
    0%{}
    50%{ transform: translateX(-200px)}
    100%{ transform: translateX(0px)}
}

.rented{color: #a46a1f;}
.repair{color: #d62728;}
.active{color: #34ce57}
</style>
